import { defineStore } from 'pinia';
import CryptoJS from 'crypto-js'; 
import { IUserProfile } from '@/interface/UserProfile.interface';
const { VITE_APP_SECRET_KEY } = import.meta.env;

const secretKey = VITE_APP_SECRET_KEY; // Load from environment variable

const encryptData = (data:any) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
};

const decryptData = (data:any) => {
  const bytes = CryptoJS.AES.decrypt(data, secretKey);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

export const useUserProfileStore = defineStore('userProfile', {
  state: () => ({
    profile: {
      id: 0,
      username: '',
      employeeId: '',
      title: '',
      firstname:  '',
      midname: '',
      lastname: '',
      displayName: '',
      email: '',
      tel: '',
      department: '',
      division:'',
      jobTitle: '',
      imgProfile: '',
      roles: [],
      permissionCode: [],
      userType: '',
      nation: '',
      roleIds: [],
    } as IUserProfile,
  }),
  actions: {
    setProfile(profile:any) {
      this.profile = profile; 
      localStorage.setItem('userProfile', JSON.stringify(profile));
    },
    loadProfile() {
      const encryptedProfile = localStorage.getItem('userProfile');
      if (encryptedProfile) {
        this.profile = JSON.parse(encryptedProfile) ; //decryptData(encryptedProfile);
      }
    },
    clearProfile() {
      this.profile = {
        id: 0,
        username: '',
        employeeId: '',
        title: '',
        firstname:  '',
        midname: '',
        lastname: '',
        displayName: '',
        email: '',
        tel: '',
        department: '',
        division:'',
        jobTitle: '',
        imgProfile: '',
        roles: [],
        permissionCode: [],
        userType: '',
        nation: '',
        roleIds: [],
      };
      localStorage.removeItem('userProfile');
    },
  },
});
